import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/auth';
import Layout from './components/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Campaigns from './pages/Campaigns';
import CampaignDetail from './pages/CampaignDetail';
import Affiliates from './pages/Affiliates';
import AffiliateDetail from './pages/AffiliateDetail';
import Players from './pages/Players';
import Traders from './pages/Traders';
import Conversions from './pages/Conversions';
import Commissions from './pages/Commissions';
import Payouts from './pages/Payouts';
import FraudRules from './pages/FraudRules';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import PaymentSettings from './pages/PaymentSettings';
import PayoutManagement from './pages/PayoutManagement';
import InvoicesPage from './pages/InvoicesPage';
import Notifications from './pages/Notifications';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="campaigns/:id" element={<CampaignDetail />} />
        <Route path="affiliates" element={<Affiliates />} />
        <Route path="affiliates/:id" element={<AffiliateDetail />} />
        <Route path="players" element={<Players />} />
        <Route path="traders" element={<Traders />} />
        <Route path="conversions" element={<Conversions />} />
        <Route path="commissions" element={<Commissions />} />
        <Route path="payouts" element={<Payouts />} />
        <Route path="fraud" element={<FraudRules />} />
        <Route path="reports" element={<Reports />} />
        <Route path="settings" element={<Settings />} />
        <Route path="profile" element={<Profile />} />
        <Route path="payment-settings" element={<PaymentSettings />} />
        <Route path="payout-management" element={<PayoutManagement />} />
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="notifications" element={<Notifications />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
